var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowRefer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.95828 1H4.76828C2.94828 1 1.86328 2.085 1.86328 3.905V8.09C1.86328 9.915 2.94828 11 4.76828 11H8.95328C10.7733 11 11.8583 9.915 11.8583 8.095V3.905C11.8633 2.085 10.7783 1 8.95828 1Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23312 8.14008C6.13812 8.14008 6.04312 8.10508 5.96812 8.03008C5.82313 7.88508 5.82313 7.64508 5.96812 7.50008L7.46812 6.00008L5.96812 4.50008C5.82313 4.35508 5.82313 4.11508 5.96812 3.97008C6.11312 3.82508 6.35313 3.82508 6.49813 3.97008L8.26312 5.73508C8.40812 5.88008 8.40812 6.12008 8.26312 6.26508L6.49813 8.03008C6.42313 8.10508 6.32812 8.14008 6.23312 8.14008Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowRefer);
export default __webpack_public_path__ + "static/media/rightArrowRefer.8872c3a086d33b32eff25f803645777d.svg";
export { ForwardRef as ReactComponent };